document.addEventListener('DOMContentLoaded', function() {
    var form = document.querySelector('form[action="/cart/add"]');
    var addToCartButton = form.querySelector('button[type="submit"]');
    var variantSelectors = form.querySelectorAll('select[name^="options"]');
    var errorContainer = document.createElement('div');
    
    errorContainer.id = 'error-message';
    errorContainer.style.color = 'red';
    errorContainer.style.display = 'none';
    errorContainer.textContent = 'Please select a size.';
    form.appendChild(errorContainer);
    
    form.addEventListener('submit', function(event) {
        var isValid = true;
        
        // Check if all required variant selectors have a value
        variantSelectors.forEach(function(selector) {
            if (!selector.value) {
                isValid = false;
            }
        });
        
        if (!isValid) {
            event.preventDefault(); // Prevent form submission
            errorContainer.style.display = 'block'; // Show the error message
        } else {
            errorContainer.style.display = 'none'; // Hide the error message if valid
        }
    });
});